import * as types from './types'

export default {
  [types.INIT_BUSINESS_DATA](state) {
    state.business = {
      id: 0,
      shopId: '',
      sid: null,
      statusId: null,
      name: null,
      timezone: null,
      phone: null,
      billSameAsPrimary: false,
      dispatchPriorityId: null,
      distributorId: null,
      salesRepId: null,
      referralSourceId: null,
      isMobileClient: false,
      isAstechClient: false,
      isCorporateAccount: false,
      accountId: null,
      annualRevenueId: null,
      monthlyRoId: null,
      locationCountId: null,
      manufacturers: [
        /* { id: 0, percent: 0 } */
      ],
      oemCertifications: [
        /* 0 */
      ],
      insuranceDepartments: [
        /* 0 */
      ],
      services: [
        /* 0 */
      ],
      primaryAddress: {
        id: 0,
        street: null,
        city: null,
        state: null,
        postalCode: null
      },
      billingAddress: {
        id: 0,
        street: null,
        city: null,
        state: null,
        postalCode: null
      },
      users: [
        // {
        //   id: 0,
        //   firstName: null,
        //   lastName: null,
        //   email: null,
        //   password: null,
        //   requiresPasswordOnSubmit: false,
        //   isEnabled: false,
        //   isLockout: false,
        //   receivesInvoices: false,
        //   receivesReports: false,
        //   receivesReportsOnly: false,
        //   isAstechUser: false,
        //   titleId: 0,
        //   phone: null
        // }
      ],
      billing: {
        isDemo: false,
        isRecurring: false,
        periodId: null,
        periodAmount: null,
        currencyId: null,
        isCurrencyIdSavedInDatabase: false
      },
      discounts: [
        // {
        //   id: 0,
        //   name: null,
        //   retailPrice: null,
        //   floor: null,
        //   isActive: true,
        //   discount: {
        //     id: 0,
        //     typeId: 0,
        //     amount: null
        //   },
        //   discountByVolume: [
        //     {
        //       id: 0,
        //       typeId: 0,
        //       volumeBreak: null,
        //       isActive: true,
        //       amount: null
        //     },
        //     {
        //       id: 0,
        //       typeId: 0,
        //       volumeBreak: null,
        //       isActive: true,
        //       amount: null
        //     }
        //   ]
        // }
      ],
      notes: [
        // {
        //   id: 0,
        //   text: 'Example',
        //   fileIds: [0],
        //   dateCreated: new Date().toISOString()
        // }
      ]
    }
  },
  [types.SET_DISCOUNT_MODAL](state, modal) {
    state.activeMappingType = modal
    if (modal === null) {
      state.business.discounts = []
    }
  },
  [types.SET_LOADING](state, { button, show }) {
    state.loading[button] = show
  },
  [types.SET_ACTIVE_TAB](state, tab) {
    state.activeTab = tab
  },
  [types.SET_BUSINESSES](state, businesses) {
    state.businesses = businesses
  },
  [types.COPY_BILLING_ADDRESS_FROM_DEFAULT](state, address) {
    state.business.billingAddress = address
  },
  [types.SET_BUSINESS_SID](state, sid) {
    state.business.sid = sid
  },
  [types.ADD_NEW_USER_TO_LIST](state) {
    state.business.users.push({
      id: 0,
      firstName: null,
      lastName: null,
      hasLogin: false,
      username: null,
      email: null,
      password: null,
      requiresPasswordOnSubmit: false,
      isPrimary: false,
      isEnabled: false,
      isLockout: false,
      isDeleted: false,
      receivesInvoices: false,
      receivesReports: false,
      receivesReportsOnly: false,
      isAstechUser: false,
      titleId: null,
      phone: null
    })
  },
  [types.SET_NEW_USER_ID](state, { user, newId }) {
    const index = state.business.users.findIndex(u => u === user)
    if (state.business.users[index].id === 0) {
      state.business.users[index].id = newId
    }
  },
  [types.ADD_MANUFACTURER](state, manufacturer) {
    state.business.manufacturers.push(manufacturer)
  },
  [types.REMOVE_MANUFACTURER](state, manufacturer) {
    var index = state.business.manufacturers.findIndex(
      x => x.id === manufacturer.id
    )
    state.business.manufacturers.splice(index, 1)
  },
  [types.UPDATE_MANUFACTURER_PERCENT](state, { id, percent }) {
    for (const manufacturer of state.business.manufacturers) {
      if (manufacturer.id === id) {
        manufacturer.percent = percent
        break
      }
    }
  },
  [types.SET_DISTRIBUTORS](state, distributors) {
    // state.distributors = distributors
  },
  [types.SET_SALES_REPS](state, salesReps) {
    // state.salesReps = salesReps
  },
  [types.ADD_DISCOUNT_BY_VOLUME_TO_PRODUCT](state, productIndex) {
    state.business.discounts[productIndex].discountsByVolume.push({
      id: null,
      typeId: null,
      amount: null,
      volumeBreak: null,
      isActive: true
    })
  },
  [types.REMOVE_DISCOUNT_BY_VOLUME_TO_PRODUCT](
    state,
    { discountIndex, productIndex }
  ) {
    state.business.discounts[productIndex].discountsByVolume.splice(
      discountIndex,
      1
    )
  },
  [types.SET_LOCATION](state, location) {
    state.business.id = location.id
    state.business.sid = location.sid
    state.business.shopId = location.shopId
    state.business.name = location.name
    state.business.timezone = location.timezone
    state.business.phone = location.phone
    state.business.billSameAsPrimary = location.billSameAsPrimary
    state.business.primaryAddress = location.primaryAddress

    state.business.billingAddress = state.business.billSameAsPrimary
      ? location.primaryAddress
      : location.billingAddress
    state.business.billingAddress.state = state.business.billSameAsPrimary
      ? location.primaryAddress.state
      : location.billingAddress.state
  },
  [types.SET_INFO](state, info) {
    if (info) {
      state.business.statusId = info.statusId
      state.business.annualRevenueId = info.annualRevenueId
      state.business.dispatchPriorityId = info.dispatchPriorityId
      state.business.distributorId = info.distributorId
      state.business.accountId = info.accountId
      state.business.monthlyRoId = info.monthlyRoId
      state.business.manufacturers = info.manufacturers || []
      state.business.services = info.services || []

      state.business.isCorporateAccount = info.isCorporateAccount
      state.business.isAstechClient = info.isAstechClient
      state.business.isMobileClient = info.isMobileClient
      state.business.salesRepId = info.salesRepId
      state.business.referralSourceId = info.referralSourceId
      state.business.locationCountId = info.locationCountId
      state.business.oemCertifications = info.oemCertifications || []
      state.business.insuranceDepartments = info.insuranceDepartments || []
    } else {
      state.business.annualRevenueId = null
      state.business.dispatchPriorityId = null
      state.business.distributorId = null
      state.business.accountId = null
      state.business.monthlyRoId = null
      state.business.manufacturers = []
      state.business.services = []

      state.business.isAstechClient = false
      state.business.isMobileClient = false
      state.business.salesRepId = null
      state.business.referralSourceId = null
      state.business.locationCountId = null
      state.business.oemCertifications = []
      state.business.insuranceDepartments = []
    }
  },
  [types.SET_USERS](state, users) {
    state.business.users = users || []
  },
  [types.SET_BILLING](state, billing) {
    state.business.billing = billing
    state.business.billing.isCurrencyIdSavedInDatabase = billing.currencyId > 0
  },
  [types.SET_DISCOUNTS](state, discounts) {
    state.business.discounts = discounts
  },
  [types.SET_NOTES](state, notes) {
    state.business.notes = notes
  },
  [types.ADD_NOTE_TO_LIST](state, note) {
    state.business.notes.unshift(note)
  },
  [types.RESET_PERIOD_DATA](state) {
    state.business.billing.periodId = null
    state.business.billing.periodAmount = null
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/business/mutations.js